module.exports = __webpack_public_path__ + "img/vegetable-parsnips-350x184.29db5517.jpg";